import type { BootstrapResponse } from '@ruby/shared';
import { create } from 'zustand';

type Status = 'loading' | 'authenticated' | 'anonymous';

interface SessionState {
  status: Status;
  /** Access token lives only in memory; the refresh token is an httpOnly cookie. */
  accessToken: string | null;
  boot: BootstrapResponse | null;
  setToken(token: string): void;
  setBoot(boot: BootstrapResponse): void;
  requirePasswordChange(): void;
  signedOut(): void;
}

export const useSession = create<SessionState>((set) => ({
  status: 'loading',
  accessToken: null,
  boot: null,
  setToken: (accessToken) => set({ accessToken }),
  setBoot: (boot) => set({ boot, status: 'authenticated' }),
  requirePasswordChange: () =>
    set((s) => (s.boot ? { boot: { ...s.boot, user: { ...s.boot.user, mustChangePassword: true } } } : s)),
  signedOut: () => set({ status: 'anonymous', accessToken: null, boot: null }),
}));
